import { InvestmentUpdate } from "@ifgengineering/client-invest-sdk";
import { signInAsync, signOutAsync } from "../auth/auth.actions";
import {
  fetchInvestmentUpdatesAPI,
  markInvestmentUpdateViewedAPI,
} from "./investmentUpdate.actions";

export interface InvestmentUpdateState {
  neverLoaded: boolean;
  loading: boolean;
  data: InvestmentUpdate[];
}

export const INITIAL_STATE: InvestmentUpdateState = {
  neverLoaded: true,
  loading: false,
  data: [],
};

const investmentUpdateReducer = (
  state = INITIAL_STATE,
  action: any
): InvestmentUpdateState => {
  switch (action.type) {
    case signInAsync.fulfilled.type:
    case signOutAsync.fulfilled.type:
      return {
        ...INITIAL_STATE,
      };
    case fetchInvestmentUpdatesAPI.pending.type:
      return {
        ...state,
        loading: true,
      };
    case fetchInvestmentUpdatesAPI.fulfilled.type:
      return {
        ...state,
        loading: false,
        neverLoaded: false,
        data: [...action.payload],
      };
    case markInvestmentUpdateViewedAPI.fulfilled.type:
      return {
        ...state,
        data: state.data.map((update) =>
          update.id === action.payload
            ? { ...update, isViewed: true }
            : update
        ),
      };
    default:
      return state;
  }
};

export default investmentUpdateReducer;
